import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Notification } from '../models/notification';

@Injectable()
export class NotificationService {
  url: string;
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseURL: string
  ) {
    this.url = baseURL;
  }

  setNotification(value: PushSubscription, uid: string) {
    console.log("Set noti")
    const sub = value.toJSON();
    console.log(sub)
    return this.http.post(`${this.url}api/Notification/setAuth_Notification`, {
      UID_Device: uid,
      Endpoint: sub.endpoint,
      P256DH: sub.keys.p256dh,
      Auth: sub.keys.auth
    }).toPromise()
    .then(result => console.log(result));
  }

  sendNotification() {
    return this.http.post(`${this.url}api/Notification/Start`, {
      Subject: this.url
    }).toPromise()
    .then(result => console.log(result));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts